import { Form, json, useActionData } from 'react-router-dom';
import Joi from 'joi';
import { fetchClient } from '../../util/fetchClient';
import logo from '../../logo.svg';

const recoverPasswordSchema = Joi.object({
  email: Joi.string().email({ tlds: { allow: false } }).required()
}).options({ abortEarly: false });

export const action = async ({ request }) => {
  const data = Object.fromEntries(await request.formData());

  try {
    await recoverPasswordSchema.validateAsync(data);
  } catch (validationError) {
    const errors = {};
    validationError?.details.map((details) => errors[details.context.key] = details.message);

    return json({ errors });
  }

  const { email } = data;
  const response = await fetchClient('/v1/auth/recover/password', { method: 'POST', body: JSON.stringify({ email }) });

  if (response.response.ok) {
    return json({ success: true });
  } else {
    return json({ success: false });
  }
};

export default function RecoverPassword() {
  const actionData = useActionData();

  return (
    <>
      <div className="flex min-h-full flex-1 items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
        <div className="w-full max-w-sm space-y-10">
          <div>
            <img
              className="mx-auto h-16 w-auto"
              src={logo}
              alt="RÖEN"
            />
            <h2 className="mt-4 text-center text-4xl font-bold leading-9 tracking-tight text-gray-900">
              Recuperar contraseña
            </h2>
          </div>

          <Form method="post" className="space-y-6">
            <div className="relative -space-y-px rounded-md shadow-sm">
              <div className="pointer-events-none absolute inset-0 z-10 rounded-md ring-1 ring-inset ring-gray-300" />
              <div>
                <label htmlFor="email" className="sr-only">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="text"
                  className={
                    actionData?.errors?.email
                      ? "block w-full rounded-md border-1 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-rose-500 placeholder:text-rose-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6"
                      : "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  }
                  placeholder="Email"
                />
              </div>
            </div>

            {
              actionData?.errors?.email && <div>
                <p className="-my-3 text-left text-sm leading-6 text-rose-600">
                  Email es inválido
                </p>
              </div>

            }

            {
              actionData?.success && <div>
                <p className="-my-3 text-left text-sm leading-6 text-green-600">
                  Hemos enviamos un email para cambiar la contraseña
                </p>
              </div>
            }

            <div>
              <button
                type="submit"
                className="disabled:bg-gray-300 disabled:text-gray-900 disabled:opacity-70 flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                disabled={actionData?.success}
              >
                Enviar email con instrucciones
              </button>
            </div>

            <div className="flex items-center justify-center">
              <div className="flex items-center">
                <p className="-py-5 block text-sm leading-6 text-gray-500">
                  ¿Tu contraseña ya ha sido recuperada? <a href="/" className="font-semibold text-indigo-600 hover:text-indigo-500">Inicia sesión</a>
                </p>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </>
  )
};
